import React from "react";
import { size } from "lodash";
import { IllustrationProps } from ".";

export default ({ colors: { base, scheme } }: IllustrationProps) => {
  const numberOfColors = size(scheme);
  const _scheme = numberOfColors === 0 ? [base] : scheme;
  const isMonochrome = size(_scheme) === 1;

  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 440 120"
      fill="none"
      strokeWidth={3}
    >
      <path
        stroke={_scheme[isMonochrome ? 0 : 1]}
        d="M0 39L148 1l149 92 143-79"
      />
      <path stroke={_scheme[0]} d="M0 106l146-23 147-63 147 53" />
      {(isMonochrome || _scheme[3]) && (
        <path
          stroke={_scheme[isMonochrome ? 0 : 3]}
          d="M0 64l146 54 147-46 147 46"
        />
      )}
    </svg>
  );
};
